import { Events, dispatch } from "../redux/dispatch";

import { useApi } from "./useApi";

export const useResults = () => {
  const { client } = useApi();
  const notifyError = () => {
    dispatch(Events.SHOW_ALERT, {
      message: "No fue posible obtener los resultados.",
      type: "ERROR",
    });
  };

  const getResults = async () => {
    try {
      const results = await client.get("/v1/pool/results");
      dispatch(Events.SET_RESULTS, results);
    } catch (err) {
      notifyError();
    }
  };

  return { getResults };
};
